import { faAngleLeft, faAngleRight, faPaperPlane } from '@fortawesome/pro-solid-svg-icons'

import WithFormFooter from '../../../../HOC/Forms/WithFormFooter'
import { getPortalOwnerName } from '../../../../utils/api/internshipRequestPortal'
import CoordinatorForm from './CoordinatorForm'
import SchoolForm from './SchoolForm'
import PlacesNeedsTable from './PlacesNeedsTable'
import SchoolPortalSummary from './SchoolPortalSummary'

export const SchoolSteps = Object.freeze({
  COORDINATOR: 0,
  SCHOOL: 1,
  REQUESTS: 2,
  SUMMARY: 3
})

const NEXT = {
  icon: faAngleRight,
  className: 'logo-colored-button blue',
  title: 'common.step.next'
}

const PREVIOUS = {
  icon: faAngleLeft,
  className: 'logo-colored-button green',
  title: 'common.step.previous'
}

const SUBMIT = {
  icon: faPaperPlane,
  className: 'logo-colored-button blue',
  title: 'school_portal.submit'
}

const SchoolPortalSteps = ({
  areas = [], countries = [], currentStep, data, errorFields = [], hospitalDepartments = [], institution, institutionGroup, isCheckingRequester = false,
  isCheckingSchool = false, minDate, sections = [],
  sectionToYears = {}, selectedArea = null, onAreaChange, onCoordinatorChange, onCancel, onNext, onPrevious, onRequestsChange,
  onSchoolChange, onSubmit
}) => (
  <>
    <WithFormFooter
      visible={currentStep === SchoolSteps.COORDINATOR}
      confirmClassName={NEXT.className}
      confirmTitle={NEXT.title}
      confirmIcon={NEXT.icon}
      disabled={isCheckingRequester}
      onConfirm={onNext}
      onCancel={onCancel}
    >
      <CoordinatorForm
        data={data.coordinator}
        errorFields={errorFields}
        onChange={onCoordinatorChange}
        emailDisabled
      />
    </WithFormFooter>

    <WithFormFooter
      visible={currentStep === SchoolSteps.SCHOOL}
      cancelTitle={PREVIOUS.title}
      cancelIcon={PREVIOUS.icon}
      confirmClassName={NEXT.className}
      confirmTitle={NEXT.title}
      confirmIcon={NEXT.icon}
      disabled={isCheckingSchool}
      onConfirm={onNext}
      onCancel={onPrevious}
    >
      <SchoolForm
        areas={areas}
        countries={countries}
        data={data.school}
        displayTitle={false}
        withEmail
        errorFields={errorFields}
        onChange={onSchoolChange}
      />
    </WithFormFooter>

    <WithFormFooter
      visible={currentStep === SchoolSteps.REQUESTS}
      cancelTitle={PREVIOUS.title}
      cancelIcon={PREVIOUS.icon}
      confirmClassName={NEXT.className}
      confirmTitle={NEXT.title}
      confirmIcon={NEXT.icon}
      onConfirm={onNext}
      onCancel={onPrevious}
    >
      <PlacesNeedsTable
        areas={areas}
        data={data.requests}
        errorFields={errorFields}
        hospitalDepartments={hospitalDepartments}
        institution={institution}
        institutionGroup={institutionGroup}
        minDate={minDate}
        sections={sections}
        sectionToYears={sectionToYears}
        selectedArea={selectedArea}
        onAreaChange={onAreaChange}
        onChange={onRequestsChange}
      />
    </WithFormFooter>

    <WithFormFooter
      visible={currentStep === SchoolSteps.SUMMARY}
      cancelTitle={PREVIOUS.title}
      cancelIcon={PREVIOUS.icon}
      confirmClassName={SUBMIT.className}
      confirmTitle={SUBMIT.title}
      confirmIcon={SUBMIT.icon}
      onConfirm={onSubmit}
      onCancel={onPrevious}
    >
      <SchoolPortalSummary
        areas={areas}
        coordinator={data.coordinator}
        countries={countries}
        institutionName={getPortalOwnerName({ institution, institutionGroup })}
        requests={data.requests}
        school={data.school}
      />
    </WithFormFooter>
  </>
)

export default SchoolPortalSteps
